// src/components/modals/DetailsModal/WordModalTabs/SeeAlsoTabSkeleton.js
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import SearchResultCardSkeleton from '../../../../search/skeletons/SearchResultCardSkeleton';

const SeeAlsoTabSkeleton = () => {
  return (
    <div className="relative px-6 pb-6 space-y-6">
      {/* Background decor - same as SeeAlsoTab */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/5"
          style={{
            background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.06), rgba(59, 130, 246, 0.04))',
            width: '110px',
            height: '110px',
            top: '15%',
            right: '8%',
            boxShadow: '0 8px 32px rgba(236, 72, 153, 0.02)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
        </div>
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/5"
          style={{
            background: 'linear-gradient(45deg, rgba(34, 197, 94, 0.05), rgba(139, 92, 246, 0.03))',
            width: '85px',
            height: '85px',
            bottom: '20%',
            right: '15%',
            boxShadow: '0 8px 32px rgba(34, 197, 94, 0.01)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
        </div>
      </div>

      {/* Skeleton Content */}
      <div className="relative space-y-6">
        {/* See Also Section */}
        <div>
          <div className="flex items-center mb-4">
            <Skeleton width={32} height={32} borderRadius={8} className="mr-3" />
            <Skeleton width={80} height={24} />
          </div>
          <div className="space-y-3">
            {Array.from({ length: 2 }).map((_, index) => (
              <SearchResultCardSkeleton key={`see-also-${index}`} />
            ))}
          </div>
        </div>

        {/* Antonyms Section */}
        <div>
          <div className="flex items-center mb-4">
            <Skeleton width={32} height={32} borderRadius={8} className="mr-3" />
            <Skeleton width={80} height={24} />
          </div>
          <div className="space-y-3">
            {Array.from({ length: 1 }).map((_, index) => (
              <SearchResultCardSkeleton key={`antonyms-${index}`} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeeAlsoTabSkeleton;
